import { FieldDefinition } from '../../../../../utils/formUtils';
import { LocationWizardStep } from './types';
import { LocationValue } from '../../../../../components/CustomFields/Location';

export const locationField: FieldDefinition<LocationWizardStep> = {
  id: 'location',
  label: 'Location',
  valueComponent: LocationValue,
};
